import actions from './actions';

const initState = { idToken:     localStorage.getItem('access_token') || null
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      console.log("authReducer ", action.token)

      return {
        idToken: action.token,
      };
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
